import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import bem from 'utils/bem';
import Text from 'components/Text';
import { IconButton } from 'components/Button';
import Page from '../Page';
import CertificateTeaser from './Teaser';
import SlideDown from 'components/SlideDown';
import { certificates, eFaq, printedFaq } from './data';
import Model from '../../../model';

import './index.sass';

const { block, el } = bem('certificates');

const Certificates = () => {

    const eFaqRef = useRef(null);
    const certificatesRef = useRef(null);
    const [ expanded, setExpanded ] = useState(true);
    const { openLoginForm } = Model.modal;
    const { isAuthenticated } = Model.user;
    const navigate = useNavigate();

    const toggleExpanded = () => setExpanded((old) => !old);

    const scrollToFAQ = () => {
        if (eFaqRef.current) {
            setTimeout(() => {
                eFaqRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 0)
            setExpanded(true);
        }
    };

    const scrollToCertificates = () => {
        if (certificatesRef.current) {
            certificatesRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }

    useEffect(() => {
        if (eFaqRef.current) {
            const button = eFaqRef.current.querySelector('#register');
            if (button) {
                button.onclick = (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (isAuthenticated) {
                        navigate('/profile');
                    } else {
                        openLoginForm({ initial: 'register' });
                    }
                }
            }
        }
    }, [ eFaqRef.current ])

    return (
        <Page className={ block() } title={ 'Сертификаты' }>
            <div className={ el('top') }>
                <div className={ el('top-content') }>
                    <div className={ el('top-text') }>
                        <Text>
                            В психотерапии есть негласное правило, которое подразумевает, что свою психотерапию должен
                            оплачивать тот самый человек, который ее проходит. Все просто: во-первых, это мнение
                            опирается на то, что мы сами ответственны за перемены в своей жизни. А во-вторых, когда мы
                            платим сами, мы чувствуем ценность того, за что платим, не делегируя ответственность.
                        </Text>
                        <Text>
                            Но иногда перемены приходят в нашу жизнь совершенно неожиданно, как будто против намеченного
                            плана. Подарком. Таким подарком может стать сертификат на консультацию с психологами проекта
                            «Ответ». Сертификат можно приобрести и для себя, чтобы использовать позже.
                        </Text>
                    </div>
                    <div className={ el('top-buttons') }>
                        <div className={ el('e-certificates') }>
                            <IconButton name={ 'arrow-right' } onClick={ scrollToCertificates }>
                                <Text>Электронные сертификаты</Text>
                            </IconButton>
                        </div>
                        <div className={ el('printed-certificates') }>
                            <IconButton name={ 'arrow-right' } to={ '/goods/tags/Сертификат' } target={ '__blank' }>
                                <Text>Печатные сертификаты</Text>
                            </IconButton>
                        </div>
                    </div>
                </div>
                <div className={ el('top-image') }>
                    <div className={ el('pic') } />
                </div>
            </div>
            <div className={ el('certificates') }>
                <div className={ el('certificates-anchor') } ref={ certificatesRef } />
                { certificates.map((cert) => <CertificateTeaser key={ cert.id } cert={ cert }
                                                                scrollToFAQ={ scrollToFAQ } />) }
            </div>
            <div className={ el('faq') }>
                <div className={ el('faq-title') }>
                    <Text serif>Как воспользоваться сертификатом</Text>
                </div>
                <div className={ el('faq-content') }>
                    <div className={ el('e-faq') } ref={ eFaqRef }>
                        { eFaq.map(({ answer, question }, index) =>
                            <SlideDown key={ index } answer={ answer } question={ question } expanded={ expanded }
                                       onClick={ toggleExpanded } />) }
                    </div>
                    <div className={ el('printed-faq') }>
                        { printedFaq.map(({ answer, question }, index) =>
                            <SlideDown key={ index } answer={ answer } question={ question } />) }
                    </div>
                </div>
            </div>
        </Page>
    )
}

export default observer(Certificates);
